export default function ArrowUp({ isRotated }) {
  return <svg className={"polymer-header-arrow-up" + (isRotated ? " polymer-header-arrow-down" : "")} width="21" height="11" viewBox="0 0 21 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5 9L10.75 2L2 9" stroke="#085054" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>;
}
